import { Component, computed, effect } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TenantDetailDto, TenantFilterDto, TenantItemDto, TenantService } from '@artemis-software/wr-api';
import { CurrentUserService } from '@services/current-user.service';
import { currentTenant, currentTenantId } from '@/utils/admin-utils';

@Component({
  standalone: false,
  selector: 'wr-contractor-tenant-overview-page',
  templateUrl: './contractor-tenant-overview-page.component.html',
  styleUrls: ['./contractor-tenant-overview-page.component.scss'],
})
export class ContractorTenantOverviewPageComponent {
  canCreate = computed(() => this.currentUserService.hasPrivilege('canCreateContractors'));
  currentTenantId = currentTenantId();
  currentTenant = currentTenant();
  form!: FormGroup;

  readonly loadTenants = (filter: TenantFilterDto) =>
    this.tenantService.findAll(this.normalizeFilter(filter));
  readonly getCount = (filter: TenantFilterDto) =>
    this.tenantService.getCount(this.normalizeFilter(filter));

  private normalizeFilter(filter: TenantFilterDto): TenantFilterDto {
    const extId = this.currentTenantId() ?? undefined;
    return {
      ...filter,
      type: TenantDetailDto.TypeEnum.Contractor,
      externalTenantId: extId
    };
  }

  constructor(private readonly router: Router,
              private readonly tenantService: TenantService,
              private readonly formBuilder: FormBuilder,
              private readonly currentUserService: CurrentUserService
  ) {
    this.form = this.formBuilder.group({
      text: this.formBuilder.control(''),
      contractorNumber: this.formBuilder.control(''),
      facilityElement: this.formBuilder.control(null),
    });
  }

  getQueryParams() {
    return { queryParams: { tenantType: 'contractor' } };
  }

  navigateToTenant(tenant: TenantItemDto): void {
    this.router.navigate(['tenant', tenant.id], this.getQueryParams());
  }

  readonly exportStreet = (tenant: TenantItemDto): string => {
    const address = tenant.paymentAddress;
    return address ? `${address.street} ${address.number}` : '';
  };

  readonly exportZip = (tenant: TenantItemDto): string => {
    const address = tenant.paymentAddress;
    return address ? `${address.country}-${address.zipCode}` : '';
  };

  add(): void {
    this.router.navigate(['tenant', 'new'], this.getQueryParams());
  }
}
